import React from "react";

// Accepts an optional onClick prop to allow parent components to intercept
// clicks (for opening a React-based lightbox) while keeping the anchor
// href for progressive enhancement / existing lightbox hooks.
export const Image = ({ title, largeImage, smallImage, onClick }) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        <a href={largeImage} title={title} data-lightbox-gallery="gallery1" onClick={handleClick}>
          <div className="hover-text">
            <h4>{title}</h4>
          </div>
          <img src={smallImage} className="img-responsive" alt={title} />
        </a>
      </div>
    </div>
  );
};
